import React from 'react';
import { Steps } from 'primereact/steps';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { items, itemsDocumento } from '../cadastrar-contratos/opcoesDropdown';

const dadosUltimoContrato = decriptObjectOnLocalStorage('dadosUltimoContrato');

const stepsComFluxoDeUpload = <Steps model={itemsDocumento} activeIndex={4} />;
const stepsSemFluxoDeUpload = <Steps model={items} activeIndex={3} />;

export const retornoEtapasCadastro = () => {
    if (dadosUltimoContrato) {
        if (
            dadosUltimoContrato.tipoVenda === 'TROCA' ||
                dadosUltimoContrato.tipoCobranca === 8
        ) {
            return stepsComFluxoDeUpload;
        } else {
            return stepsSemFluxoDeUpload;
        }
    } else {
        return stepsSemFluxoDeUpload;
    }
};